import { useState } from 'react';

import { cn } from '@/shared/utils/cn';

export interface SelectMenuOptionLeadingProps {
  label: string;
  imageUrl?: string;
  imageAlt?: string;
  className?: string;
}

/** Optional thumbnail for {@link SelectMenu} rows; falls back to initials when the image is missing or fails. */
export function SelectMenuOptionLeading({
  label,
  imageUrl,
  imageAlt,
  className,
}: SelectMenuOptionLeadingProps) {
  const [imgFailed, setImgFailed] = useState(false);
  const src = imageUrl?.trim() ?? '';
  const showImg = src.length > 0 && !imgFailed;

  return (
    <div
      className={cn(
        'grid h-10 w-10 shrink-0 place-items-center overflow-hidden rounded border border-border bg-surface-muted',
        className,
      )}
      aria-hidden={showImg ? undefined : true}
    >
      {showImg ? (
        <img
          src={src}
          alt={imageAlt ?? label}
          className="h-full w-full object-cover"
          loading="lazy"
          decoding="async"
          onError={() => setImgFailed(true)}
        />
      ) : (
        <span className="text-xs font-semibold text-fg-muted">
          {label.slice(0, 2).toUpperCase()}
        </span>
      )}
    </div>
  );
}
